import React from "react";
import UploadCheque from "../../organisms/InitialPagesComponents/BankKyc/UploadCheque/UploadCheque";

function UploadChequePage() {
  return <UploadCheque />;
}

export default UploadChequePage;
